module.exports = __webpack_public_path__ + "static/hb-team-c12c16cf16350f72a63365c69a445b30.jpg";